import { MONETATE_DECISIONS_URL, MONETATE_REQUEST_METHOD } from 'constants/monetate';
import apiClient from 'api/client/index';
import { parseMonetateResponse } from 'redux/modules/experiments/actions/parse-monetate-response';
import {
  MonetateActions,
  MonetateApiRequestBody,
  MonetateApiResponse,
} from 'redux/modules/experiments/actions/types';

interface FetchMonetateActionsParams {
  requestBody: MonetateApiRequestBody;
  requestId: string;
  timeout: {
    response: number;
    deadline: number;
  };
}

export const fetchMonetateActions = async ({
  requestBody,
  requestId,
  timeout,
}: FetchMonetateActionsParams): Promise<MonetateActions | undefined> => {
  try {
    const result: MonetateApiResponse = await apiClient({
      data: requestBody,
      url: MONETATE_DECISIONS_URL,
      method: MONETATE_REQUEST_METHOD,
      timeout,
      requestId,
      withCredentials: false,
    });

    const monetateId = result?.meta?.monetateId;
    const actions = result?.data?.responses?.[0]?.actions ?? [];
    const parsedMonetateResponse = parseMonetateResponse(actions);

    return {
      ...parsedMonetateResponse,
      monetateId,
    };
  } catch {
    return undefined;
  }
};
